import { render, staticRenderFns } from "./WarningBuySubscriptionModal.vue?vue&type=template&id=7464df04"
import script from "./WarningBuySubscriptionModal.vue?vue&type=script&lang=js"
export * from "./WarningBuySubscriptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports